// this we showed in the organizaion
export const COMMON_TIMEZONES: { label: string, value: string }[] = [
    { label: "Eastern — New York (ET)", value: "America/New_York" },
    { label: "Central — Chicago (CT)", value: "America/Chicago" },
    { label: "Mountain — Denver (MT)", value: "America/Denver" },
    { label: "Pacific — Los Angeles (PT)", value: "America/Los_Angeles" },
];

export const FACILITY_TIMEZONES: { label: string, value: string }[] = [
    { label: "Eastern Time (ET)", value: "America/New_York" },
    { label: "Central Time (CT)", value: "America/Chicago" },
    { label: "Mountain Time (MT)", value: "America/Denver" },
    { label: "Pacific Time (PT)", value: "America/Los_Angeles" },
  ];